/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/contextHelpers.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Helper functions for generating context from name.
────────────────────────────────────────────────────────────────*/

/**
 * Generate context from name: lowercase, no spaces, no special characters, max 50 chars
 */
export function generateContextFromName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/^_|_$/g, '')
    .substring(0, 50);
}

